import { Box } from '@mui/material';
import { useListContext, useTranslate } from 'react-admin';
import { AnalyticsChartTitle } from '@/components/analytics/common/AnalyticsChartTitle.jsx';
import { ProductAnalyticsInfo } from '@/components/analytics/product/ProductAnalyticsInfo.jsx';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const TransactionPayoutAnalytics = () => {
    const { data } = useListContext();
    const translate = useTranslate();
    if (!data || data.length === 0) return null;
    const analytic = data[0].data;

    const payouts = [
        ['cash', analytic.transactionsCashCount],
        ['loyaltyPoints', analytic.transactionsLoyaltyPointsCount],
        ['discount', analytic.transactionsDiscountCount],
        ['pointsAndDiscount', analytic.transactionsPointsAndDiscountCount],
        ['cashDiscount', analytic.transactionsCashDiscountCount],
        ['campaign', analytic.transactionsCampaignCount],
        ['cashAndPoints', analytic.transactionsCashAndPointsCount],
        ['card', analytic.transactionsCardCount],
        ['noPayout', analytic.transactionsNoPayoutCount],
    ].sort(([, a], [, b]) => b - a);

    return (
        <Box
            sx={{
                backgroundColor: Palette.white,
                padding: '40px 40px 48px',
                borderRadius: '16px',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    padding: '24px',
                },
            }}
        >
            <AnalyticsChartTitle title={translate('analytics.transaction.payoutForms')} />
            <Box sx={{ marginTop: '26px' }}>
                {payouts.map(([code, value]) => (
                    <ProductAnalyticsInfo
                        key={code}
                        code={translate(`selectOptions.depositWithdrawalMethodsChoices.${code}`)}
                        validateCode={false}
                        value={value}
                        total={analytic.transactionsCount}
                    />
                ))}
            </Box>
        </Box>
    );
};
